import { ConvertedRealEstate, RealEstate } from '../../../../@types/real-estate-api-types'
import { metaToApp } from './metaToApp'
import { listingToApp } from './listingToApp'
import { geoCoordinatesToApp } from './geoCoordinatesToApp'
import { attachmentsToApp } from './attachmentsToApp'
import { ContentStateInterface, EntryMode } from '../../../../@types/types'
import { manualAddress } from './manualAddress/manualAddress'

export const realEstateToApp = (
  realEstate: RealEstate,
  defaultStateValues: ContentStateInterface,
  entryMode?: EntryMode
): ConvertedRealEstate => ({
  meta: metaToApp(realEstate, entryMode),
  listing: listingToApp(realEstate, defaultStateValues),
  attachments: realEstate.attachments ? attachmentsToApp(realEstate.attachments) : [],
  ...geoCoordinatesToApp(realEstate.address.geoCoordinates),
  ...(realEstate.address.manual && manualAddress(realEstate.address.manual)),
  category: realEstate.category,
  publishInfo: realEstate.publishInfo,
  tenantNetwork: realEstate.tenantNetwork,
})
